import { Image } from "capitalrx-components-2.0/";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Semibold, Regular } from "capitalrx-components-2.0/lib/typography";

import styles from "./WhiteLabelWaysToSave.module.scss";

import coin from "@/static/images/money.svg?url";
import card from "@/static/images/Union.svg?url";
import wallet from "@/static/images/wallet.svg?url";

interface BoxProps {
  icon: "coin" | "card" | "wallet"
  number: string
  boldText: string
  text: string
}

export const WaysToSaveBox = (props: BoxProps) => {
  const { icon, number, boldText, text } = props;

  const image = () => {
    if (icon === "coin") return coin;
    if (icon === "card") return card;
    if (icon === "wallet") return wallet;
  };

  return (
    <div className={styles.WaysToSaveBox}>
      <span className={styles.WaysToSaveBoxIcon}><Image src={image()} alt={icon} /></span>
      <Shelf>
        <span className={styles.WaysToSaveBoxNumber}>{number}</span>
        <span>
          <Regular><Semibold>{boldText}</Semibold></Regular><br />
          <Regular>{text}</Regular>
        </span>
      </Shelf>
    </div>
  );
};
